import React, { useState } from "react";
import { Button, Card, Empty, Space, Typography, Upload, message } from "antd";
import {
    DownloadOutlined,
    EyeOutlined,
    FilePdfOutlined,
    UploadOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

function AttachmentRow({
    title,
    fileName,
    onView,
    onDownload,
    onUpload,
}) {
    const [uploading, setUploading] = useState(false);

    const uploadProps = {
        accept: ".pdf,application/pdf",
        showUploadList: false,
        beforeUpload: async (file) => {
            if (!onUpload) return false;

            try {
                setUploading(true);
                await onUpload(file);
            } finally {
                setUploading(false);
            }

            return false;
        },
    };

    const hasFile = !!fileName;

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
                padding: "10px 12px",
                border: "1px solid #f0f0f0",
                borderRadius: 10,
                background: "#fafafa",
            }}
        >
            <Space size={10} style={{ minWidth: 0 }}>
                <FilePdfOutlined style={{ fontSize: 18, color: "#cf1322" }} />
                <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 600 }}>{title}</div>
                    <Text
                        type="secondary"
                        style={{
                            fontSize: 12,
                            display: "block",
                            maxWidth: 320,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                        title={fileName || "-"}
                    >
                        {fileName || "Файл байхгүй"}
                    </Text>
                </div>
            </Space>

            <Space size={8}>
                {hasFile ? (
                    <>
                        <Button icon={<EyeOutlined />} onClick={onView}>
                            Харах
                        </Button>
                        <Button icon={<DownloadOutlined />} onClick={onDownload}>
                            Татах
                        </Button>
                    </>
                ) : (
                    <Upload {...uploadProps}>
                        <Button icon={<UploadOutlined />} loading={uploading}>
                            PDF нэмэх
                        </Button>
                    </Upload>
                )}
            </Space>
        </div>
    );
}

function TransactionScheduleAttachments({ attachments = [] }) {
    if (!attachments.length) {
        return (
            <Card size="small" title="Хавсралтууд">
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Хавсралт байхгүй" />
            </Card>
        );
    }

    return (
        <Card
            size="small"
            title="Хавсралтууд"
            bodyStyle={{ display: "flex", flexDirection: "column", gap: 12 }}
        >
            {attachments.map((item) => (
                <AttachmentRow
                    key={item.key}
                    title={item.title}
                    fileName={item.fileName}
                    onView={item.onView}
                    onDownload={item.onDownload}
                    onUpload={item.onUpload}
                />
            ))}
        </Card>
    );
}

export default TransactionScheduleAttachments;